// src/components/outputs/blogSeo/BlogSeoResultEntry.jsx — the body of a Blog SEO history card.
//
// The one format with its own screen (Figma «Content Generator 1.1»): the main
// card (BlogSeoCard: Testo | HTML | META, «Copia», «Scarica tutto»).
// renderResultEntry.jsx sends here every entry whose builder is the blog's
// (builderKeyFor === 'blog-seo'); every other format keeps PiecesResultEntry.
// An entry the blog builder gives no article piece for (no readable content)
// falls back to PiecesResultEntry.
//
// The design's Qualità | Fonti side panel is NOT drawn (product decision of
// 2026-11-02: removed for now); the claims and sources panels below the card
// stay the card's (Step3History / RunDetailPage). Its rule for «Influenza delle
// fonti» is kept, pure and tested, in ./sourceInfluence.js for when it returns.
//
// Same props as PiecesResultEntry: { entry, copiedId, onCopy, t, w }.

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../../../constants/theme.js';
import { piecesForEntry, builderKeyFor } from '../../../publish/pieces/index.js';
import PiecesResultEntry from '../PiecesResultEntry.jsx';
import BlogSeoCard from './BlogSeoCard.jsx';

const defaultW = (o) => `rgba(255,255,255,${o})`;

export const BLOG_SEO_KEY = 'blog-seo';

/** Whether an entry is drawn by this screen (the blog's builder). */
export const isBlogSeoEntry = (entry) => builderKeyFor(entry) === BLOG_SEO_KEY;

export default function BlogSeoResultEntry({ entry, copiedId, onCopy, t = {}, w = defaultW }) {
  const { i18n } = useTranslation('outputs');
  const language = i18n.language;
  // `language` on purpose: labels inside the list follow it (piecesForEntry caches per language).
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const pieces = useMemo(() => piecesForEntry(entry), [entry, language]);

  if (!pieces.some((p) => p && p.id === 'article')) {
    return <PiecesResultEntry entry={entry} copiedId={copiedId} onCopy={onCopy} t={t} w={w} />;
  }

  return (
    <div data-testid="blogseo-result-entry">
      <BlogSeoCard entry={entry} pieces={pieces} copiedId={copiedId} onCopy={onCopy} t={t} w={w} color={COLORS.accent} />
    </div>
  );
}
